import { EDIT_TOKEN_HEADER, EDIT_TOKEN_STORAGE_KEYS } from '@messenger/consts'
import { axios } from '@/api/axios.config'
import { orderSessionId } from './orderSession'

/** Whether this tab is signed in: `Auth0.tsx` puts the JWT on the client. */
const hasJwt = (): boolean => {
  const authorization: unknown =
    axios.defaults.headers.common?.['Authorization']
  return typeof authorization === 'string' && authorization.length > 0
}

/**
 * The headers an order edit session sends: the order it is scoped to
 * (`x-order`) and, for a designer or QC session, the edit token it was
 * opened with, from which the backend reads the session's role. Empty when
 * the tab is signed in with a JWT, which the backend would otherwise judge
 * as the edit link of whatever order another tab left, or when the tab
 * holds no order.
 */
export const orderTokenHeaders = (): Record<string, string> => {
  if (hasJwt()) return {}
  const orderId = orderSessionId()
  if (!orderId) return {}
  const editToken = sessionStorage.getItem(EDIT_TOKEN_STORAGE_KEYS.token)
  return {
    'x-order': orderId,
    ...(editToken ? { [EDIT_TOKEN_HEADER]: editToken } : {}),
  }
}

/** The fetch options that send `orderTokenHeaders()`, or none when empty. */
export const orderTokenRequestOptions = ():
  | { headers: Record<string, string> }
  | undefined => {
  const headers = orderTokenHeaders()
  return Object.keys(headers).length > 0 ? { headers } : undefined
}
